import { render } from "./UnsubribeOption.vue?vue&type=template&id=3f79c2a1"
import script from "./UnsubribeOption.vue?vue&type=script&lang=js"
export * from "./UnsubribeOption.vue?vue&type=script&lang=js"

import "./UnsubribeOption.vue?vue&type=style&index=0&id=3f79c2a1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__